import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/timeoff/lib/SettingsCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
